import React from 'react';
import LegalDocument from '../components/common/LegalDocument';

const CopyrightPolicy: React.FC = () => {
  return (
    <LegalDocument
      title="Copyright Policy"
      lastUpdated="March 20, 2024"
    >
      <h2>1. Copyright Protection</h2>
      <p>
        All content included on XTEA, including but not limited to text, graphics, logos, 
        button icons, images, audio clips, digital downloads, data compilations, and software, 
        is the property of XTEA or its content suppliers and is protected by international 
        copyright laws.
      </p>

      <h2>2. License and Site Access</h2>
      <p>
        XTEA grants you a limited license to access and make personal use of this platform. 
        This license does not include:
      </p>
      <ul>
        <li>Any resale or commercial use of this platform or its contents</li>
        <li>Any collection and use of any product listings, descriptions, or prices</li>
        <li>Any derivative use of this platform or its contents</li>
        <li>Any downloading or copying of account information for the benefit of another merchant</li>
        <li>Any use of data mining, robots, or similar data gathering and extraction tools</li>
      </ul>

      <h2>3. DMCA Compliance</h2>
      <p>
        We respect the intellectual property rights of others and expect our users to do the same. 
        In accordance with the Digital Millennium Copyright Act (DMCA), we will respond to notices 
        of alleged copyright infringement that comply with applicable law.
      </p>

      <h2>4. Copyright Infringement Claims</h2>
      <p>
        If you believe that any material on our platform violates your copyright, you may request 
        removal of those materials by submitting written notification to our copyright agent. 
        Your written notification must include:
      </p>
      <ul>
        <li>An electronic or physical signature of the copyright owner or authorized person</li>
        <li>Identification of the copyrighted work claimed to have been infringed</li>
        <li>Description of where the infringing material is located on our platform</li>
        <li>Your contact information (address, telephone number, and email)</li>
        <li>A statement that you have a good faith belief that the disputed use is not authorized</li>
        <li>A statement, under penalty of perjury, that the information in your notice is accurate</li>
      </ul>

      <h2>5. Counter-Notification</h2>
      <p>
        If you believe your content was wrongly removed due to a mistake or misidentification, 
        you may submit a counter-notification to our copyright agent containing:
      </p>
      <ul>
        <li>Your physical or electronic signature</li>
        <li>Identification of the material removed and its previous location</li>
        <li>A statement under penalty of perjury that you have a good faith belief the material 
            was removed by mistake</li>
        <li>Your name, address, and telephone number</li>
        <li>Your consent to the jurisdiction of federal district court</li>
      </ul>

      <h2>6. Repeat Infringers</h2>
      <p>
        It is our policy to terminate the accounts of users who repeatedly infringe or are 
        repeatedly charged with infringing the copyrights or other intellectual property 
        rights of others.
      </p>

      <h2>7. Contact Information</h2>
      <p>
        For copyright matters, please contact our copyright agent at:
      </p>
      <p>
        Email: copyright@xtea.app<br />
        Address: [Your Company Address]<br />
        Phone: [Your Company Phone]
      </p>

      <h2>8. Modifications</h2>
      <p>
        We reserve the right to modify this Copyright Policy at any time. Changes and 
        clarifications will take effect immediately upon their posting on the platform. 
        If we make material changes to this policy, we will notify you that it has been 
        updated.
      </p>

      <h2>9. User-Generated Content</h2>
      <p>
        By posting, uploading, or submitting any content to our platform, you grant XTEA 
        a non-exclusive, royalty-free, perpetual, irrevocable, and fully sublicensable right 
        to use, reproduce, modify, adapt, publish, translate, create derivative works from, 
        distribute, and display such content throughout the world in any media.
      </p>

      <h2>10. Fair Use</h2>
      <p>
        Nothing in this Copyright Policy is intended to limit any rights you might have to 
        fair use, fair dealing, or other similar copyright exceptions and limitations.
      </p>
    </LegalDocument>
  );
};

export default CopyrightPolicy; 